import { displayModes } from 'services/enums/displayModes';
import Columns from './columns';

// CARE: ALWAYS INCREMENT THE VERSION IF THE SETTINGS FOR A COLUMN CHANGE!
// Config explanation
// optional: determines if the hidden status can be changed by the user
// hidden: determines if the field is shown or hidden
// conditional: indicates that the hidden status can be overriden using the conditions dictionary of the useTableConfig hook
const DefaultConfig = {
  [displayModes.admin]: {
    version: 3,
    columns: {
      templateStopId: {
        columnName: Columns.templateStopId.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 1,
      },
      stopType: {
        columnName: Columns.stopType.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 2
      },
      shipper: {
        columnName: Columns.shipper.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 3
      },
      stopCategory: {
        columnName: Columns.stopCategory.name,
        optional: true,
        hidden: false,
        conditional: false,
        order: 4
      },
      name: {
        columnName: Columns.name.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 5
      },
      address: {
        columnName: Columns.address.name,
        optional: true,
        hidden: false,
        conditional: false,
        order: 6
      },
      deliveryWindow: {
        columnName: Columns.deliveryWindow.name,
        optional: true,
        hidden: true,
        conditional: false,
        order: 7
      },
      options: {
        columnName: Columns.options.name,
        optional: false,
        hidden: false,
        conditional: true,
        order: 8
      },
    }
  },
  [displayModes.shipper]: {
    version: 3,
    columns: {
      templateStopId: {
        columnName: Columns.templateStopId.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 1
      },
      stopCategory: {
        columnName: Columns.stopCategory.name,
        optional: true,
        hidden: false,
        conditional: false,
        order: 2
      },
      name: {
        columnName: Columns.name.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 3
      },
      address: {
        columnName: Columns.address.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 4
      },
      deliveryWindow: {
        columnName: Columns.deliveryWindow.name,
        optional: true,
        hidden: true,
        conditional: false,
        order: 5
      },
      options: {
        columnName: Columns.options.name,
        optional: false,
        hidden: false,
        conditional: true,
        order: 6
      },
    }
  },
}

export default DefaultConfig;